const NUMBER_FORMAT = new Intl.NumberFormat("fr-FR", { maximumFractionDigits: 0 });

export function formatAriary(value) {
    return `${NUMBER_FORMAT.format(Number(value) || 0)} Ar`;
}

export function formatDuesMonth(month) {
    if (!/^\d{4}-\d{2}$/.test(month || "")) return month || "";
    const [year, number] = month.split("-").map(Number);
    const value = new Intl.DateTimeFormat("fr-FR", { month: "short", year: "numeric", timeZone: "UTC" })
        .format(new Date(Date.UTC(year, number - 1, 1)));
    return value.charAt(0).toUpperCase() + value.slice(1).replace(".", "");
}

export function duesStatusLabel(obligation) {
    if (obligation?.not_applicable || obligation?.status === "not_applicable") return "N/A";
    if (obligation?.exempt) return "Dispensée";
    return obligation?.status === "paye" ? "Payée" : "Impayée";
}

export function canRecordDuesPayment(obligation) {
    return Boolean(obligation && !obligation.not_applicable && !obligation.exempt && !obligation.payment && !obligation.legacy_payment_conflict);
}

export function summarizeCotisation(payments) {
    const cotisations = payments.filter((payment) => payment.type === "cotisation");
    if (cotisations.length === 0) return null;

    const paid = cotisations.reduce((total, payment) => total + Number(payment.amount_paid || 0), 0);
    const due = cotisations.reduce((total, payment) => total + Number(payment.amount_due || 0), 0);
    const remaining = Math.max(due - paid, 0);
    let label = "À payer";
    if (paid >= due) label = "À jour";
    else if (paid > 0) label = "Partiellement payée";
    return { paid, due, remaining, label };
}

export function summarizeAttendance(entries) {
    if (entries.length === 0) return null;
    const counts = entries.reduce((summary, entry) => {
        if (Object.prototype.hasOwnProperty.call(summary, entry.status)) summary[entry.status] += 1;
        return summary;
    }, { present: 0, absent: 0, retard: 0 });
    const attended = counts.present + counts.retard;
    return {
        ...counts,
        attended,
        total: entries.length,
        rate: Math.round((attended / entries.length) * 1000) / 10,
    };
}

export function groupMatches(matches) {
    const upcoming = matches
        .filter((match) => match.status === "scheduled")
        .sort((a, b) => `${a.date} ${a.time || ""}`.localeCompare(`${b.date} ${b.time || ""}`));
    const results = matches
        .filter((match) => match.status === "played")
        .sort((a, b) => `${b.date} ${b.time || ""}`.localeCompare(`${a.date} ${a.time || ""}`));
    return { next: upcoming[0] || null, results: results.slice(0, 3) };
}

export const attendanceLabels = {
    present: "Présent",
    absent: "Absent",
    retard: "En retard",
};
